/* Skeleton block that mimics <OrderSummary> layout
   ----------------------------------------------- */

export const OrderSummarySkeleton = () => (
  <div className="animate-pulse space-y-4 rounded-sm border-xs border-[#cbcbcb] p-24">
    <div className="h-5 w-32 rounded bg-[#e5e5e5]" />
    <div className="h-[1px] w-full bg-[#e5e5e5]" />
    <div className="h-5 w-2/3 rounded bg-[#e5e5e5]" />
    <div className="h-[1px] w-full bg-[#e5e5e5]" />
    <div className="h-5 w-1/2 rounded bg-[#e5e5e5]" />
    <div className="h-[1px] w-full bg-[#e5e5e5]" />
    <div className="h-6 w-full rounded bg-[#e5e5e5]" />
  </div>
)
